export const ROLE_COMPANY_USER = 'company-user'
export const ROLE_SUPER_ADMIN = 'super-admin'
export const ROLE_COMPANY_ADMIN = 'company-admin'
export const ROLE_SITE_ADMIN = 'site-admin'
export const ROLE_DEVELOPER = 'developer'
export const ROLE_DEVELOPER_RW = 'developer-rw'
